module.exports = __webpack_public_path__ + "img/4.adcae5c4.jpg";